export const GET_AGGREGATION_LEVEL = 'GET_AGGREGATION_LEVEL';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CLAIM_CONFIGURATION_SUCCESS = 'CLAIM_CONFIGURATION_SUCCESS';
export const BUDGET_CONFIGURATION_SUCCESS = 'BUDGET_CONFIGURATION_SUCCESS';
export const CLAIM_ERROR_SUCCESS = 'CLAIM_ERROR_SUCCESS';
export const GET_AGGREGATION_LEVEL_BY_ID = 'GET_AGGREGATION_LEVEL_BY_ID';
export const CLAIM_ERROR_SINGLE_SUCCESS = 'CLAIM_ERROR_SINGLE_SUCCESS';
